import React from 'react';
import { Component } from "puzzle"

type PROPS = {
  actionName: 'promote' | 'demote'
  previousPhase: string
}

export class FileHasNoChanges extends Component<PROPS, {}> {
  renderBody = () => {
    const {
      actionName,
      previousPhase
    } = this.props as PROPS;
    return (
      <div className={'tp-warning-text'}>
        <span>
          <div className={'tp-font-size-md tp-text-semibold tp-dialog-subtitle'}>
            {this.translate('subTitle')}
          </div>
        <div>
          {
            this.translate(`${actionName}Text`, {
              className: 'tp-text-semibold',
              previousPhase
            })
          }
        </div>
        </span>
      </div>
    )
  }
}
